function distKey(item) {
  const d = item?.distance_km;
  if (d == null || d === '') return Number.POSITIVE_INFINITY;
  const n = parseFloat(d);
  return Number.isFinite(n) ? n : Number.POSITIVE_INFINITY;
}

/**
 * Client-side browse ordering for merged feeds (luxury/wedding).
 * Matches server rules: proximity baseline, user sort on top with distance tiebreaker.
 */
export function sortBrowseItems(items, sortKey) {
  const list = [...(items || [])];
  const byPriceLow = (a, b) => parseFloat(a.price) - parseFloat(b.price);
  const byPriceHigh = (a, b) => parseFloat(b.price) - parseFloat(a.price);
  const byNewest = (a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
  const byOldest = (a, b) => new Date(a.created_at).getTime() - new Date(b.created_at).getTime();
  const withProximityTiebreak = (primary) => (a, b) => {
    const p = primary(a, b);
    if (p !== 0) return p;
    return distKey(a) - distKey(b);
  };

  const effective = sortKey === 'nearest' ? 'recommended' : sortKey;

  switch (effective) {
    case 'price-low':
      return list.sort(withProximityTiebreak(byPriceLow));
    case 'price-high':
      return list.sort(withProximityTiebreak(byPriceHigh));
    case 'newest':
      return list.sort(withProximityTiebreak(byNewest));
    case 'oldest':
      return list.sort(withProximityTiebreak(byOldest));
    case 'recommended':
    default:
      return list.sort((a, b) => {
        const d = distKey(a) - distKey(b);
        if (d !== 0) return d;
        return byNewest(a, b);
      });
  }
}
